import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";

import ordersService from "@services/orders";
import providersService from "@services/providers";

import "react-confirm-alert/src/react-confirm-alert.css";
import { 
  MdAddCircleOutline, 
  MdVisibility, 
  MdError,
  MdTrendingUp,
  MdTrendingDown,
  MdDescription,
  MdAttachMoney,
  MdCancel,
  MdBusiness
} from "react-icons/md";
import ReactTable from "@components/ReactTable";
import "./list.css";

// Components
import Menu from "@components/Menu";
import Input from "@components/Input";
import AutoComplete from "@components/AutoComplete";
import Modal from "@components/Modal";
import DateRangePicker from "@components/DateRangePicker";
import Checkbox from "@components/CheckBox";

import { threeDecimal } from "@utils/format";
// Import mantido apenas como fallback caso a API ainda retorne lines em alguns casos
import { totals } from "./utils/totals";

import { EventBus as eventBus } from "@components/EventBus";

class Page extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      statistics: {
        totalDocuments: 0,
        totalDocumentsVariation: 0,
        quotes: 0,
        orders: 0,
        returns: 0,
        transfers: 0,
        totalValue: 0,
        totalValueVariation: 0,
        cancelledOrders: 0,
        cancelledOrdersVariation: 0,
        totalProviders: 0,
        totalProvidersVariation: 0,
        loading: true
      },
      doctype: JSON.parse(localStorage.getItem("orders.doctype")) || {
        value: '',
        label: 'TODOS',
      },
      doctypes: [
        {
          value: "",
          label: "TODOS",
        },
        {
          value: "orders",
          label: "Compras",
        },
        {
          value: "returns",
          label: "Devoluções",
        },
        {
          value: "transfer",
          label: "Transferências",
        },
        {
          value: "inventory",
          label: "Inventário",
        },
        {
          value: "quotes",
          label: "Encomendas",
        },
      ],
      table: {
        columns: [
          {
            Header: "Data",
            accessor: "date",
          },
          {
            Header: "Fornecedor",
            accessor: "provider_name",
          },
          {
            Header: "Nº Documento",
            accessor: "doc",
          },
          {
            Header: "Tipo Doc",
            accessor: "doctypelabel",
          },
          {
            Header: "Total",
            accessor: "total",
          },
          {
            Header: "Anulada",
            accessor: "deleted",
          },
          {
            Header: "",
            accessor: "view",
          },
        ],
        data: [],
        pages: null,
        loading: true,
      },
      search: JSON.parse(localStorage.getItem("orders.search")) || "",
      idprovider: JSON.parse(localStorage.getItem("orders.idprovider")) || {
        value: "",
        label: "TODOS",
      },
      date: [new Date().setHours(0 , 0 , 0) , new Date().setHours (23 , 59 , 59)],
      useDate: false,
    };
    this.loadFunction = this.loadFunction.bind(this);
    this.loadTableOnly = this.loadTableOnly.bind(this);
    this.loadStatisticsOnly = this.loadStatisticsOnly.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.localDateChange = this.localDateChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.fetchTableData = this.fetchTableData.bind(this);
  }

  async loadFunction() {
    if (!this.state.loaded) {
      const idempresa = this.props.cookies.get("member_idempresa");

      try {
        // Load providers
        const providers = await providersService.get(idempresa);
        this.setState({ 
          providers: [
            {
              value: "",
              label: "TODOS",
            },
            {
              value: '-1',
              label: 'Indiferenciado'
            },
            ...providers.map((provider) => ({ ...provider, value: provider.idprovider, label: provider.name }))
          ], 
          loaded: true 
        });

        // Carregar dados iniciais da tabela com paginação
        const defaultState = {
          page: 0,
          pageSize: 10,
        };
        this.fetchTableData(defaultState, {});
        
        // Carregar estatísticas
        this.loadStatisticsOnly();
      } catch (error) {
        console.error(error);
      }
    }
  }

  calculateStatistics(orders, providers) {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    
    // Filtrar por fornecedor se selecionado (exceto quando "TODOS" é selecionado)
    const filteredOrders = this.state.idprovider && this.state.idprovider.value && this.state.idprovider.value !== ""
      ? orders.filter(order => order.idprovider === this.state.idprovider.value)
      : orders;
    
    // Filtrar ordens do mês atual
    const currentMonthOrders = filteredOrders.filter(order => {
      const orderDate = new Date(order.date_time * 1000);
      return orderDate.getMonth() === currentMonth && orderDate.getFullYear() === currentYear;
    });
    
    // Filtrar ordens do mês anterior
    const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear;
    const lastMonthOrders = filteredOrders.filter(order => {
      const orderDate = new Date(order.date_time * 1000);
      return orderDate.getMonth() === lastMonth && orderDate.getFullYear() === lastMonthYear;
    });

    // Calcular estatísticas do mês atual
    const currentStats = this.calculateMonthStats(currentMonthOrders);
    const lastMonthStats = this.calculateMonthStats(lastMonthOrders);

    // Calcular variações percentuais
    const calculateVariation = (current, previous) => {
      if (previous === 0) return current > 0 ? 100 : 0;
      return ((current - previous) / previous) * 100;
    };

    // Fornecedores únicos do mês atual
    // Se idprovider = -1, mostrar 0
    // Se um fornecedor específico está selecionado, mostrar 1
    // Se "TODOS" está selecionado, mostrar o número real de fornecedores únicos
    const currentProviders = this.state.idprovider && this.state.idprovider.value === "-1"
      ? 0  // Fornecedor -1 selecionado
      : this.state.idprovider && this.state.idprovider.value && this.state.idprovider.value !== ""
      ? 1  // Fornecedor específico selecionado
      : new Set(
          currentMonthOrders
            .filter(order => order.valid !== false && order.idprovider !== '-1' && order.idprovider !== '')
            .map(order => order.idprovider)
        ).size;  // Todos os fornecedores únicos

    const lastMonthProviders = this.state.idprovider && this.state.idprovider.value === "-1"
      ? 0  // Fornecedor -1 selecionado
      : this.state.idprovider && this.state.idprovider.value && this.state.idprovider.value !== ""
      ? 1  // Fornecedor específico selecionado
      : new Set(
          lastMonthOrders
            .filter(order => order.valid !== false && order.idprovider !== '-1' && order.idprovider !== '')
            .map(order => order.idprovider)
        ).size;  // Todos os fornecedores únicos

    return {
      // Card 1: Total de Documentos
      totalDocuments: currentStats.totalOrders,
      totalDocumentsVariation: calculateVariation(currentStats.totalOrders, lastMonthStats.totalOrders),
      quotes: currentStats.quotes,
      orders: currentStats.orders,
      returns: currentStats.returns,
      transfers: currentStats.transfers,
      
      // Card 2: Valor Total
      totalValue: currentStats.totalValue,
      totalValueVariation: calculateVariation(currentStats.totalValue, lastMonthStats.totalValue),
      
      // Card 3: Compras Anuladas
      cancelledOrders: currentStats.cancelledOrders,
      cancelledOrdersVariation: calculateVariation(currentStats.cancelledOrders, lastMonthStats.cancelledOrders),
      
      // Card 4: Fornecedores
      totalProviders: currentProviders,
      totalProvidersVariation: calculateVariation(currentProviders, lastMonthProviders)
    };
  }

  calculateMonthStats(orders) {
    const validOrders = orders.filter(order => order.valid !== false);
    const cancelledOrders = orders.filter(order => order.valid === false);

    // Contar por tipo de documento
    const ordersValues = validOrders.filter(order => order.doctype === 'orders');
    const returns = validOrders.filter(order => order.doctype === 'returns');
    const transfers = validOrders.filter(order => order.doctype === 'transfer');
    const quotes = validOrders.filter(order => order.doctype === 'quotes');

    const totalValue = ordersValues.reduce((sum, order) => {
      const total = typeof order.total === 'string' ? parseFloat(order.total.replace(',', '.')) : parseFloat(order.total);
      return sum + (total || 0);
    }, 0) - returns.reduce((sum, order) => {
      const total = typeof order.total === 'string' ? parseFloat(order.total.replace(',', '.')) : parseFloat(order.total);
      return sum + (total || 0);
    }, 0);

    return {
      totalOrders: validOrders.length,
      totalValue,
      cancelledOrders: cancelledOrders.length,
      quotes: quotes.length,
      orders: ordersValues.length,
      returns: returns.length,
      transfers: transfers.length,
    };
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
      [name]: value,
      table: {
        ...this.state.table,
        loading: true,
      }
    }, () => {
        switch (name) {
            // case "date":
            case "doctype":
            case "idprovider":
            case "search":
                localStorage.setItem(`orders.${name}`, JSON.stringify(value));
                break;
            default:
                break;
            }
        
        // Recalcular estatísticas se for o filtro de fornecedor
        if (name === 'idprovider') {
          this.setState({
            statistics: {
              ...this.state.statistics,
              loading: true
            }
          }, () => {
            this.loadStatisticsOnly();
          });
        }
        
        // Recarregar tabela com novos filtros (resetar para página 1)
        const defaultState = {
          page: 0,
          pageSize: this.state.table.pageSize || 10,
        };
        this.fetchTableData(defaultState, {});
    });
  }

  handleCheckboxChange(e, callback) {
    let value = e.target.checked;
    let name = e.target.name;

    this.setState({
      [name]: value,
      table: {
        ...this.state.table,
        loading: true,
      }
    }, () => {
      // Para mudanças de checkbox, apenas recarregar a tabela sem recalcular estatísticas
      const defaultState = {
        page: 0,
        pageSize: this.state.table.pageSize || 10,
      };
      this.fetchTableData(defaultState, {});
    });
  }

  fetchTableData(state, instance) {
    // Função chamada pelo ReactTable para carregar dados com paginação e filtros
    const { history } = this.props;
    const { date, useDate, doctype, idprovider, search } = this.state;
    const idempresa = this.props.cookies.get("member_idempresa");

    // Atualizar estado de loading
    this.setState({
      table: {
        ...this.state.table,
        loading: true,
      },
    });

    // Preparar filtros para a API
    const filters = {};
    
    if (useDate && date && date[0] && date[1]) {
      filters.start_date = date[0] / 1000;
      filters.end_date = date[1] / 1000;
    }
    
    if (doctype && doctype.value) {
      filters.doctype = doctype.value;
    }
    
    if (idprovider && idprovider.value && idprovider.value !== "") {
      filters.idprovider = idprovider.value;
    }
    
    if (search && search.trim() !== "") {
      filters.search = search.trim();
    }
    
    // Adicionar paginação
    filters.page = (state.page || 0) + 1; // ReactTable usa índice 0, API usa índice 1
    filters.pageSize = state.pageSize || 10;

    // Carregar dados da API
    ordersService.get(idempresa, filters)
      .then((response) => {
        const orders = response.entries || [];
        
        const enrichedOrders = orders.map((order) => {
          // Usar total já calculado pela API, ou calcular como fallback se ainda existir lines
          const total = order.total !== undefined && order.total !== null 
            ? order.total 
            : (order.lines ? totals(order.lines, order.doctype).total : 0);
          
          // Usar provider_name da API se existir, senão procurar no estado
          const providerName = order.provider_name || (() => {
            const provider = this.state.providers?.find(
              (provider) => provider.value === order.idprovider
            );
            return provider ? provider.label : "Fornecedor não encontrado";
          })();
          
          // Usar doctypelabel se não existir, procurar no estado
          const doctypeLabel = order.doctypelabel || (
            this.state.doctypes.find(
              (docType) => docType.value === order.doctype
            ) || {}
          ).label || order.doctype;
          
          return {
            ...order,
            provider_name: providerName,
            doctypelabel: doctypeLabel,
            date:
              ['quotes'].includes(order.doctype) ? 
              new Date(parseInt(order.date_time) * 1000).toLocaleString('pt-PT', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }) :
              new Date(parseInt(order.date_time) * 1000).toLocaleString('pt-PT', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
              }),
            total: threeDecimal(total),
            view: (
              <>
                {(order.errors || []).length > 0 ? <MdError
                  style={{ fontSize: "15px", color: '#CCCC00', cursor: "pointer" }}
                  onClick={() => eventBus.$emit("Modal-errors", { header: "Erros", body: order.errors.map((error) => (<p>- {error}</p>)) })}
                /> : null}
                <MdVisibility
                  style={{ fontSize: "15px", cursor: "pointer" }}
                  onClick={() => history.push(`/orders/${order.idorder}`)}
                />
              </>
            ),
            deleted: order.valid ? "" : "TRUE",
          };
        });        
        this.setState({
          table: {
            ...this.state.table,
            data: enrichedOrders,
            pages: response.totalPages || 0,
            loading: false,
          },
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          table: {
            ...this.state.table,
            data: [],
            pages: 0,
            loading: false,
          },
        });
      });
  }

  async loadTableOnly() {
    // Carrega apenas a tabela sem recalcular estatísticas (mantido para compatibilidade)
    // Agora usa fetchTableData com estado padrão
    const defaultState = {
      page: 0,
      pageSize: 10,
    };
    this.fetchTableData(defaultState, {});
  }

  loadStatisticsOnly() {
    // Recalcula apenas as estatísticas usando os dados já carregados
    // Para estatísticas, precisamos carregar todos os dados do mês atual
    const idempresa = this.props.cookies.get("member_idempresa");
    
    // Carregar todos os dados do mês atual para estatísticas (sem paginação)
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    const monthStart = new Date(currentYear, currentMonth, 1);
    const monthEnd = new Date(currentYear, currentMonth + 1, 0, 23, 59, 59);
    
    const statsFilters = {
      start_date: Math.floor(monthStart.getTime() / 1000),
      end_date: Math.floor(monthEnd.getTime() / 1000),
      page: 1,
      pageSize: 10000, // Número grande para obter todos os registos
    };
    
    if (this.state.idprovider && this.state.idprovider.value && this.state.idprovider.value !== "") {
      statsFilters.idprovider = this.state.idprovider.value;
    }
    
    ordersService.get(idempresa, statsFilters)
      .then((response) => {
        const orders = response.entries || [];
        const enrichedOrders = orders.map((order) => {
          // Usar total já calculado pela API, ou calcular como fallback se ainda existir lines
          const total = order.total !== undefined && order.total !== null 
            ? order.total 
            : (order.lines ? totals(order.lines, order.doctype).total : 0);
          
          return {
            ...order,
            total: threeDecimal(total),
          };
        });
        
        // Calcular estatísticas
        const stats = this.calculateStatistics(enrichedOrders, this.state.providers);
        
        this.setState({
          statistics: {
            ...stats,
            loading: false
          }
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          statistics: {
            ...this.state.statistics,
            loading: false
          }
        });
      });
  }

  localDateChange(date) {
    this.setState({ 
      date: [
        date[0].setHours(0 , 0 , 0),
        date[1].setHours(23 , 59 , 59),
      ],
      useDate: true,
      table: {
        ...this.state.table,
        loading: true,
      }
    }, () => {
      // Para mudanças de data, apenas recarregar a tabela sem recalcular estatísticas
      const defaultState = {
        page: 0,
        pageSize: this.state.table.pageSize || 10,
      };
      this.fetchTableData(defaultState, {});
    });
  }

  render() {
    const { table, search, providers, idprovider, doctypes, doctype, useDate, date, statistics } = this.state;
    const { location, history } = this.props;
    const cookies = new URLSearchParams(location.search);


    return (
      <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: "left",
                marginTop: "75px",
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li className="active">Compras</li>
            </ol>
          </div>
        </div>

        {/* Seção de Estatísticas Ultra Compacta com Detalhes */}
        <div className="stats-section">
          <div className="stats-section-header">
            <h3 className="stats-title">
              Estatísticas - Mês atual
              {idprovider && idprovider.value && idprovider.value !== "" && (
                <span className="stats-subtitle"> - {idprovider.label}</span>
              )}
            </h3>
          </div>
          <div className="stats-cards-container">
            {/* Card 1: Total de Documentos */}
          <div className="stat-card total">
            <div className="stat-card-header">
              <div className="stat-card-icon">
                <MdDescription />
              </div>
              <div className="stat-card-content">
                <div className="stat-value">
                  {statistics.loading ? (
                    <div className="stat-loading">
                      <div className="loading-spinner"></div>
                    </div>
                  ) : (
                    statistics.totalDocuments.toLocaleString()
                  )}
                </div>
                <p className="stat-label">Documentos</p>
              </div>
            </div>
            <div className={`stat-change ${statistics.totalDocumentsVariation >= 0 ? 'positive' : 'negative'}`}>
              {statistics.totalDocumentsVariation >= 0 ? <MdTrendingUp /> : <MdTrendingDown />}
              {statistics.totalDocumentsVariation >= 0 ? '+' : ''}{statistics.totalDocumentsVariation.toFixed(1)}% (mês anterior)
            </div>
          </div>

          {/* Card 2: Valor Total */}
          <div className="stat-card value">
            <div className="stat-card-header">
              <div className="stat-card-icon">
                <MdAttachMoney />
              </div>
              <div className="stat-card-content">
                <div className="stat-value">
                  {statistics.loading ? (
                    <div className="stat-loading">
                      <div className="loading-spinner"></div>
                    </div>
                  ) : (
                    `${statistics.totalValue.toLocaleString('pt-PT', { minimumFractionDigits: 0 })} €`
                  )}
                </div>
                <p className="stat-label">Valor Total <span>(compras - devoluções)</span></p>
              </div>
            </div>
            <div className={`stat-change ${statistics.totalValueVariation >= 0 ? 'positive' : 'negative'}`}>
              {statistics.totalValueVariation >= 0 ? <MdTrendingUp /> : <MdTrendingDown />}
              {statistics.totalValueVariation >= 0 ? '+' : ''}{statistics.totalValueVariation.toFixed(1)}% (mês anterior)
            </div>
            <div className="stat-comparison">
              <div className="comparison-item">
                <span className="comparison-label">Mês atual:</span>
                <span className="comparison-value">{statistics.totalValue.toLocaleString('pt-PT', { minimumFractionDigits: 0 })} €</span>
              </div>
              <div className="comparison-item">
                <span className="comparison-label">Variação:</span>
                <span className="comparison-value">
                  {statistics.totalValueVariation >= 0 ? '+' : ''}{statistics.totalValueVariation.toFixed(1)}%
                  <span className={`comparison-change ${statistics.totalValueVariation >= 0 ? 'positive' : 'negative'}`}>
                    {statistics.totalValueVariation >= 0 ? '↗' : '↘'}
                  </span>
                </span>
              </div>
            </div>
          </div>

          {/* Card 3: Compras Anuladas */}
          <div className="stat-card pending">
            <div className="stat-card-header">
              <div className="stat-card-icon">
                <MdCancel />
              </div>
              <div className="stat-card-content">
                <div className="stat-value">
                  {statistics.loading ? (
                    <div className="stat-loading">
                      <div className="loading-spinner"></div>
                    </div>
                  ) : (
                    statistics.cancelledOrders
                  )}
                </div>
                <p className="stat-label">Anuladas</p>
              </div>
            </div>
            <div className={`stat-change ${statistics.cancelledOrdersVariation >= 0 ? 'positive' : 'negative'}`}>
              {statistics.cancelledOrdersVariation >= 0 ? <MdTrendingUp /> : <MdTrendingDown />}
              {statistics.cancelledOrdersVariation >= 0 ? '+' : ''}{statistics.cancelledOrdersVariation.toFixed(1)}% (mês anterior)
            </div>
            <div className="stat-comparison">
              <div className="comparison-item">
                <span className="comparison-label">Mês atual:</span>
                <span className="comparison-value">{statistics.cancelledOrders}</span>
              </div>
              <div className="comparison-item">
                <span className="comparison-label">Variação:</span>
                <span className="comparison-value">
                  {statistics.cancelledOrdersVariation >= 0 ? '+' : ''}{statistics.cancelledOrdersVariation.toFixed(1)}%
                  <span className={`comparison-change ${statistics.cancelledOrdersVariation >= 0 ? 'positive' : 'negative'}`}>
                    {statistics.cancelledOrdersVariation >= 0 ? '↗' : '↘'}
                  </span>
                </span>
              </div>
            </div>
          </div>

          {/* Card 4: Fornecedores */}
          <div className="stat-card providers">
            <div className="stat-card-header">
              <div className="stat-card-icon">
                <MdBusiness />
              </div>
              <div className="stat-card-content">
                <div className="stat-value">
                  {statistics.loading ? (
                    <div className="stat-loading">
                      <div className="loading-spinner"></div>
                    </div>
                  ) : (
                    statistics.totalProviders
                  )}
                </div>
                <p className="stat-label">Fornecedores</p>
              </div>
            </div>
            <div className={`stat-change ${statistics.totalProvidersVariation >= 0 ? 'positive' : 'negative'}`}>
              {statistics.totalProvidersVariation >= 0 ? <MdTrendingUp /> : <MdTrendingDown />}
              {statistics.totalProvidersVariation >= 0 ? '+' : ''}{statistics.totalProvidersVariation.toFixed(1)}% (mês anterior)
            </div>
            <div className="stat-comparison">
              <div className="comparison-item">
                <span className="comparison-label">Mês atual:</span>
                <span className="comparison-value">{statistics.totalProviders}</span>
              </div>
              <div className="comparison-item">
                <span className="comparison-label">Variação:</span>
                <span className="comparison-value">
                  {statistics.totalProvidersVariation >= 0 ? '+' : ''}{statistics.totalProvidersVariation.toFixed(1)}%
                  <span className={`comparison-change ${statistics.totalProvidersVariation >= 0 ? 'positive' : 'negative'}`}>
                    {statistics.totalProvidersVariation >= 0 ? '↗' : '↘'}
                  </span>
                </span>
              </div>
            </div>
          </div>
          </div>
        </div>

        {/* Seção de Filtros Moderna */}
        <div className="filters-section">
          <div className="filters-header">
            <h3 className="filters-title">Filtros de Documentos</h3>
            <button 
              className="create-document-btn"
              onClick={() => history.push("/orders/new")}
            >
              <MdAddCircleOutline />
              <span>Criar Documento</span>
            </button>
          </div>
          
          <div className="filters-container">
            <div className="filter-group">
              <label className="filter-label">Fornecedor</label>
              <AutoComplete
                name={"idprovider"}
                value={idprovider}
                handleChange={this.handleChange}
                options={providers}
              />
            </div>
            
            <div className="filter-group">
              <label className="filter-label">Tipo de Documento</label>
              <AutoComplete
                name={"doctype"}
                value={doctype}
                handleChange={this.handleChange}
                options={doctypes}
              />
            </div>
            
            <div className="filter-group">
              <label className="filter-label">Período</label>
              <div className="date-filter-container">
                <div className="date-checkbox-wrapper">
                  <Checkbox
                    name={"useDate"}
                    checked={useDate}
                    position={"left"}
                    handleChange={this.handleCheckboxChange}
                  />
                  <span className="date-label">Filtrar por data</span>
                </div>
                {useDate && (
                  <div className="date-picker-wrapper">
                    <DateRangePicker 
                      maxDate={new Date()} 
                      value={date} 
                      onChange={this.localDateChange}
                      withPortal={true}
                      portalId="date-picker-portal"
                    />
                  </div>
                )}
              </div>
            </div>
            
            <div className="filter-group">
              <label className="filter-label">Pesquisar Documento</label>
              <Input
                inputType={"text"}
                name={"search"}
                value={search}
                handleChange={this.handleChange}
                placeholder="Número do documento..."
              />
            </div>
          </div>
        </div>

        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-sm-12" style={{ textAlign: "center" }}>
            <div className="panel panel-default">
              <ReactTable
                columns={table.columns}
                manual
                sortable={false}
                loading={table.loading}
                data={table.data}
                pages={table.pages}
                onFetchData={this.fetchTableData}
                defaultPageSize={10}
              />
            </div>
          </div>
        </div>
        <Modal id="errors" />
        <div id="date-picker-portal"></div>
      </div>
    );
  }
}

export default withCookies(withRouter(Page));
